<template>
  <div class="cell-container" :cell-type="thumbnailInfo.cellType">
    <ul class="cell-list scroll cell-autoplay">
      <li v-for="(cell, index) in cellList" :key="'instanceCell_' + index">
        <a @click.prevent="selectCell(cell)" href="#">
          <div class="cell-img home">
            <img v-lazy="getLazyLoadObj(cell)" :alt="altTitle(cell)"/>
            <div class="tag-top tag-list"></div>
            <ul class="badge-list">
              <li class="left-top-area">
                <ul v-top-tag-list="{'badgeList': topTagList, 'badgeType': 'artwork'}"></ul>
              </li>
              <li class="right-top-area" v-common-tag-list="{'badgeList': brandTagList, 'type': 'brand'}"></li>
  <!--            <li class="center-bottom-area" v-common-tag-list="{'badgeList': updateTagList, 'type': 'label'}"></li>-->
            </ul>
            <age-tag v-if="cell.age_tag !== ''" :age-code="cell.age_tag"/>
            <div class="progress-bar" v-if="progress(cell) !== ''" v-progress-bar="progress(cell) * 100"></div>
          </div>
          <div class="cell-info">
            <div class="cell-title-wrap" v-title-list="{'titleList': titleList(cell)}"></div>
          </div>
        </a>
        <icon-box-zzim-with-event :event-list="eventList(cell)" :zzim="zzim(cell)"></icon-box-zzim-with-event>
      </li>
    </ul>
  </div>
</template>
<script>
import { resizeThumbnail } from '@/common/image.filter'
import { get } from 'lodash'
import { progressBar, titleList, topTagList, commonTagList } from '@/common/directives'
import { EventBus } from '@/components/eventbus/EventBus'
import { ON_CLICK } from '@/common/event.const'
import { parseUrl } from 'query-string'
import { getEventListByType } from '@/common/util/event.util'
import { getTitle } from '@/common/util/common'
import IconBoxZzimWithEvent from '@/components/play/IconBoxZzimWithEvent'
import { PATH_NAME_PLAYER } from '@/common/router.const'
import AgeTag from '@/components/tags/AgeTag'
export default {
  name: 'CellListInstantPlayBand',
  props: {
    cellList: {
      type: Array
    },
    thumbnailInfo: {
      type: Object
    }
  },
  components: {
    AgeTag,
    IconBoxZzimWithEvent
  },
  directives: {
    titleList,
    progressBar,
    topTagList,
    commonTagList
  },
  methods: {
    getLazyLoadObj (cell) {
      return {
        src: resizeThumbnail(get(cell, 'thumbnail', ''), this.thumbnailInfo),
        error: this.thumbnailInfo.loadingImageUrl,
        loading: this.thumbnailInfo.loadingImageUrl
      }
    },
    selectCell (cell) {
      const { onNavigationEvent, onClickEvent } = getEventListByType(cell.event_list)
      if (onClickEvent) {
        EventBus.$emit(ON_CLICK, onClickEvent)
      }
      let navigationUrl = get(onNavigationEvent, 'url', '').replace('.html', '')
      let { url, query } = parseUrl(navigationUrl)
      let section = url.split('/').pop()
      if (section === 'list') {
        this.$router.push({
          name: 'channelclip',
          params: {
            uiCode: query.uicode
          }
        })
      } else {
        this.$router.push({
          name: PATH_NAME_PLAYER,
          params: {
            section
          },
          query: query
        })
      }
    },
    altTitle (cell) {
      return getTitle(cell)
    },
    titleList (cell) {
      return get(cell, 'title_list', '')
    },
    progress (cell) {
      return get(cell, 'progress', '')
    },
    eventList (cell) {
      return get(cell, 'event_list', [])
    },
    zzim (cell) {
      return get(cell, 'iszzim', 'n').toLowerCase()
    }
  },
  mounted() {
    console.log(this.cellInfo)
  }
}
</script>
